import React, { useState } from 'react';
import {
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableRow,
  TableBody,
  Typography,
  useTheme,
  Box,
} from '@mui/material';
import { CustomTableHead, CustomTableHeadCell, CustomTableRow } from '../../components/@extended/CustomTable';
import moment from 'moment';
import RightArrow from '../../components/icons/RightArrow';
import { useNavigate, useParams } from 'react-router-dom';
import CustomCard from '../../components/@extended/CustomCard';
import CustomButton from '../../components/@extended/CustomButton';
import AddIcon from '@mui/icons-material/Add';
import { useGetSiteBasicDetailsQuery } from '../../store/slices/apiSlice';
import AddSite from '../createTrial/siteDetails/AddSite';
import { useDispatch } from 'react-redux';
import { openMessage } from '../../store/slices/showMessageSlice';

const siteTableColumns = [
  {
    id: 'orgname',
    label: 'Site Name',
    style: {
      minWidth: 200,
      textAlign: 'left',
    },
    align: 'left',
  },
  {
    id: 'address',
    label: 'Address',
    style: {
      minWidth: 250,
      textAlign: 'left',
    },
    align: 'left',
  },
  {
    id: 'fax',
    label: 'Fax',
    style: {
      minWidth: 150,
      textAlign: 'left',
    },
    align: 'left',
  },
  {
    id: 'createdAt',
    label: 'Created Date',
    style: {
      minWidth: 150,
      textAlign: 'center',
    },
    align: 'center',
  },
  {
    id: 'rightArrow',
    label: '',
    style: {
      minWidth: 50,
      textAlign: 'right',
    },
    align: 'right',
  },
];

const SitesTable = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { sponsorId } = useParams();
  const [openAddSite, setOpenAddSite] = useState(false);
  
  const { data: sites, isLoading } = useGetSiteBasicDetailsQuery({ sponsorId });

  const handleCloseAddSite = () => {
    setOpenAddSite(false);
  };

  const openMessageNotification = ({ message, type }) => {
    dispatch(openMessage({ messageSeverity: type, message }));
  };

  if (isLoading) {
    return <></>;
  }

  return (
    <>
      <CustomCard
        title={
          <Typography variant="h6" fontWeight={600} color={theme.palette.grey[800]}>
            Sites
          </Typography>
        }
        action={
          <Box sx={{ display: 'flex', columnGap: 2, alignItems: 'center' }}>
            <CustomButton
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => setOpenAddSite(true)}
            >
              Create New Site
            </CustomButton>
          </Box>
        }
      >
        <TableContainer sx={{ maxHeight: 550 }}>
          <Table stickyHeader aria-label="sticky table">
            <CustomTableHead>
              <TableRow>
                {siteTableColumns.map((column) => (
                  <CustomTableHeadCell key={column.id} align={column.align} sx={{ ...column.style }}>
                    {column.label}
                  </CustomTableHeadCell>
                ))}
              </TableRow>
            </CustomTableHead>
            <TableBody>
              {sites && sites.length > 0 ? (
                sites.map((row) => (
                  <CustomTableRow
                    key={row.id}
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    sx={{ cursor: 'pointer' }}
                    onClick={() => navigate(`/sponsorDisplay/${sponsorId}/site/${row.id}`)}
                  >
                    <TableCell>
                      <Typography variant="subtitle1">{row.orgname}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">{row.address || 'N/A'}</Typography>
                    </TableCell>
                    <TableCell>{row.fax || 'N/A'}</TableCell>
                    <TableCell align="center">
                      {moment(row.createdAt).format('DD/MM/YYYY')}
                    </TableCell>
                    <TableCell align="right">
                      <RightArrow onClick={() => navigate(`/sponsorDisplay/${sponsorId}/site/${row.id}`)} />
                    </TableCell>
                  </CustomTableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell align="center" colSpan={siteTableColumns.length}>
                    <Typography variant="subtitle1" color="initial">
                      No Sites Found
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </CustomCard>
      <AddSite
        open={openAddSite}
        handleClose={handleCloseAddSite}
        openMessageNotification={openMessageNotification}
        sponsorId={sponsorId}
      />
    </>
  );
};

export default SitesTable;

